import React, { FunctionComponent } from 'react'
import { View, ViewStyle } from 'react-native'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { InsightsOrbIcon } from './InsightsOrbIcon'

export interface ConnectInsightsSearchIconProps {
  fillColor?: string
  style?: ViewStyle
}

export const ConnectInsightsSearchIcon: FunctionComponent<ConnectInsightsSearchIconProps> = ({ fillColor, style }) => {
  const { colors } = useTheme()
  return (
    <View
      style={[{ position: 'relative', width: 24, height: 24, overflow: 'visible' }, style]}
      accessible={false}
      accessibilityElementsHidden={true}
      importantForAccessibility='no'
    >
      <Svg width={19} height={19} viewBox='0 0 19 19' fill='none' style={{ position: 'absolute', bottom: 0, left: 0 }}>
        <Path
          d='M7.19238 0C6.87756 0.492159 6.63279 1.03321 6.47168 1.60938C3.633 2.19936 1.5 4.71483 1.5 7.72852C1.5 11.1803 4.29822 13.9785 7.75 13.9785C10.7639 13.9785 13.2785 11.8449 13.8682 9.00586C14.4445 8.84478 14.9853 8.60002 15.4775 8.28516C15.3602 9.93806 14.7268 11.4475 13.7344 12.6523L18.2803 17.1982C18.5732 17.4911 18.5732 17.9659 18.2803 18.2588C17.9874 18.5517 17.5126 18.5517 17.2197 18.2588L12.6738 13.7129C11.335 14.8157 9.62002 15.4785 7.75 15.4785C3.46979 15.4785 0 12.0087 0 7.72852C0 3.63585 3.17251 0.285863 7.19238 0Z'
          fill={fillColor || colors.iconDefault}
        />
      </Svg>
      <View style={{ position: 'absolute', top: 2, left: 7, zIndex: 1, overflow: 'visible' }}>
        <InsightsOrbIcon size={12} />
      </View>
    </View>
  )
}
